import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor() { }

  isEmpty(value: any): boolean {
    // Check for null or undefined
    if (value == null) return true;

    // Check for empty string
    if (typeof value === 'string' && value.trim() === '') return true;

    // Check for empty object
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;

    return false;
  }

  generateId = (): string => {
    // Alphanumeric characters
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let autoId = '';
    for (let i = 0; i < 20; i++) {
      autoId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // assert(autoId.length === 20, "Invalid auto ID: " + autoId);
    return autoId;
  }
}